import Vue from "vue";
import reverse from 'lodash/reverse';

export default {
    state: {
        bundle: null,
    },

    mutations: {
        setBundle(state, bundle) {
            state.bundle = {
                ...state.bundle,
                ...bundle
            };
        },

        addOrUpdatePage(state, page) {
            if (state.bundle) {
                let pageIndex = (state.bundle.pages || []).findIndex(p => p.id === page.id);

                if (pageIndex >= 0) {
                    Vue.set(state.bundle.pages, pageIndex, {
                        ...state.bundle.pages[pageIndex],
                        ...page
                    });
                } else {
                    if (!state.bundle.pages) {
                        Vue.set(state.bundle, 'pages', []);
                    }

                    state.bundle.pages.push({ ...page });
                }
            }
        },

        deletePage(state, page) {
            if (state.bundle) {
                let pageIndex = (state.bundle.pages || []).findIndex(p => p.id === page.id);

                if (pageIndex >= 0) {
                    Vue.delete(state.bundle.pages, pageIndex);
                }
            }
        },

        addAttachment(state, attachment) {
            let pageId = attachment.page_id;
            let page = (state.bundle.pages || []).find(p => p.id === pageId);

            if (page) {
                if (!page.attachments) {
                    Vue.set(page, 'attachments', []);
                }

                page.attachments.push({ ...attachment });
            }
        },

        updateAttachment(state, attachment) {
            let pageId = attachment.page_id;
            let page = (state.bundle.pages || []).find(p => p.id === pageId);

            if (page) {
                let attachmentIndex = -1;
                
                if (attachment.temp_id) {
                    attachmentIndex = (page.attachments || []).findIndex(att => att.temp_id === attachment.temp_id);
                }

                if (attachmentIndex < 0) {
                    attachmentIndex = (page.attachments || []).findIndex(att => att.id === attachment.id);
                }

                if (attachmentIndex >= 0) {
                    Vue.set(page.attachments, attachmentIndex, {
                        ...page.attachments[attachmentIndex],
                        ...attachment
                    });
                }
            }
        },

        deleteAttachment(state, attachment) {
            let pageId = attachment.page_id;
            let page = (state.bundle.pages || []).find(p => p.id === pageId);

            if (page) {
                let attachmentIndex = -1;

                if (attachment.temp_id) {
                    attachmentIndex = (page.attachments || []).findIndex(att => att.temp_id === attachment.temp_id);
                }

                if (attachmentIndex < 0) {
                    attachmentIndex = (page.attachments || []).findIndex(att => att.id === attachment.id);
                }

                if (attachmentIndex >= 0) {
                    if (page.attachments[attachmentIndex].cancelSource) {
                        page.attachments[attachmentIndex].cancelSource.cancel('Attachment deleted');
                    }

                    Vue.delete(page.attachments, attachmentIndex);
                }
            }
        },

        addOrUpdateContentBlock(state, contentBlock) {
            let pageId = contentBlock.page_id;
            let page = (state.bundle.pages || []).find(p => p.id === pageId);

            if (page) {
                if (!page.content_blocks) {
                    Vue.set(page, 'content_blocks', []);    
                }

                let blockIndex = -1;

                if (contentBlock.temp_id) {
                    blockIndex = page.content_blocks.findIndex(b => b.temp_id === contentBlock.temp_id);
                }

                if (blockIndex < 0 && contentBlock.id > 0) {
                    blockIndex = page.content_blocks.findIndex(b => b.id === contentBlock.id);
                }

                if (blockIndex >= 0) {
                    Vue.set(page.content_blocks, blockIndex, {
                        ...page.content_blocks[blockIndex],
                        ...contentBlock
                    });
                } else {
                    page.content_blocks.push({ ...contentBlock });
                }
            }
        },

        deleteContentBlock(state, contentBlock) {
            let pageId = contentBlock.page_id;
            let page = (state.bundle.pages || []).find(p => p.id === pageId);

            if (page) {
                let blockIndex = -1;

                if (contentBlock.temp_id) {
                    blockIndex = page.content_blocks.findIndex(b => b.temp_id === contentBlock.temp_id);
                }

                if (blockIndex < 0 && contentBlock.id > 0) {
                    blockIndex = (page.content_blocks || []).findIndex(b => b.id === contentBlock.id);
                }

                if (blockIndex >= 0) {
                    if (page.content_blocks[blockIndex].cancelSource) {
                        page.content_blocks[blockIndex].cancelSource.cancel('Content block deleted');
                    }

                    Vue.delete(page.content_blocks, blockIndex);
                }
            }
        },
    },

    getters: {
        bundle: (state) => {
            return state.bundle;
        },

        pages: (state) => {
            return state.bundle ? (state.bundle.pages || []) : [];
        },

        contentBlocks: (state, getters) => {
            return getters.pages.map(page => page.content_blocks).flat();
        },

        findPage: (state, getters) => (pageId) => {
            return getters.pages.find(page => page.id === parseInt(pageId));
        },

        attachmentsForPage: (state, getters) => (pageId) => {
            return (getters.findPage(pageId) || {}).attachments || [];
        },

        findContentBlock: (state, getters) => (blockId, blockTempId) => {
            return getters.contentBlocks.find(block => {
                if (!blockId && blockTempId) {
                    return block.temp_id === blockTempId;
                }

                return block.id === blockId;
            });
        },

        contentBlocksForPage: (state, getters) => (pageId) => {
            return (getters.findPage(pageId) || {}).content_blocks || [];
        },

        groupedPages: (state, getters) => {
            return (getters.pages)
                .filter(page => page.parent_page_id === null)
                .sort((a, b) => a.order - b.order)
                .map(page => {
                    page.child_pages = (getters.pages || [])
                        .filter(p => p.parent_page_id === page.id)
                        .sort((a, b) => a.order - b.order);

                    return page;
                });
        },
    },
}